import React from 'react';
import PropTypes from 'prop-types';

import ManagedInput from 'components/form/managed_input';
import ManagedFormGroup from 'components/form/managed_input/form_group';
import Options from 'components/form/managed_input/options';

export default function CustomFieldFormMarketingFields({ customField, features, options, onChange }) {
  if (!features.marketingIntegration || !customField.classFlags.deal || customField.classFlags.comp) {
    return null;
  }

  function toggleMarketing(enable) {
    if (enable) {
      const type = options.marketingTypes[0].value;
      const field = getMarketingFieldOptionsForType(options, type)[0].value;
      onChange({ marketing: { type, field } });
    } else {
      onChange({ marketing: null });
    }
  }

  function handleChange(changes) {
    onChange({ marketing: { ...customField.marketing, ...changes } });
  }

  return <React.Fragment>
    <ManagedInput
      checked={customField.marketing != null}
      className="my-3"
      label="Associate With Marketing?"
      type="checkbox"
      onValueChange={toggleMarketing}
    />

    {customField.marketing != null &&
      <React.Fragment>
        <ManagedFormGroup
          label="Marketing Model"
          name="type"
          required
          type="select"
          value={customField.marketing.type}
          onChange={handleChange}
        >
          <Options options={options.marketingTypes} />
        </ManagedFormGroup>

        <ManagedFormGroup
          label="Marketing Field"
          name="field"
          required
          type="select"
          value={customField.marketing.field}
          onChange={handleChange}
        >
          <Options options={getMarketingFieldOptionsForType(options, customField.marketing.type)} />
        </ManagedFormGroup>
      </React.Fragment>
    }
  </React.Fragment>;
}

function getMarketingFieldOptionsForType(options, type) {
  return options.marketingFieldsAndTypes
    .find(option => option.type === type)
    .fields
    .map(field => ({ label: field, value: field }));
}

CustomFieldFormMarketingFields.propTypes = {
  customField: PropTypes.shape({
    classFlags: PropTypes.shape({
      comp: PropTypes.bool,
    }).isRequired,
    marketing: PropTypes.shape({
      type: PropTypes.string,
      field: PropTypes.string,
    }),
  }).isRequired,
  features: PropTypes.shape({
    marketingIntegration: PropTypes.bool,
  }).isRequired,
  fieldsByType: PropTypes.object.isRequired,
  options: PropTypes.shape({
    marketingTypes: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    })),
  }).isRequired,
  onChange: PropTypes.func.isRequired,
};
